import script from "./CustomerShow.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerShow.vue?vue&type=script&setup=true&lang=js"

import "./CustomerShow.vue?vue&type=style&index=0&id=3d4cb96a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4cb96a"]])

export default __exports__